var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusTransportvehicleSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 32 32",
    enableBackground: "new 0 0 32 32",
    id: "_x3C_Layer_x3E_",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 1.3119999999999998,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bus_x2C__transport_x2C_vehicle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_598_"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "XMLID_599_",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 20,
    x2: 10.5,
    y1: 25.5,
    y2: 25.5
  }), /*#__PURE__*/React.createElement("path", {
    d: " M24.5,15.5l6,2.08V17.5l-1.36-6.78c-0.08-0.44-0.25-0.85-0.46-1.22H24.5V15.5z",
    fill: "none",
    id: "XMLID_600_",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 6,
    id: "XMLID_601_",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    width: 6,
    x: 6.5,
    y: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 6,
    id: "XMLID_602_",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    width: 6,
    x: 12.5,
    y: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 6,
    id: "XMLID_603_",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    width: 6,
    x: 18.5,
    y: 9.5
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    id: "XMLID_604_",
    points: " 1.5,15.5 6.5,15.5 6.5,9.5 3.68,9.5 ",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "XMLID_605_",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 24,
    x2: 3.5,
    y1: 28.5,
    y2: 28.5
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "XMLID_606_",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 1.6,
    x2: 1.5,
    y1: 28.5,
    y2: 28.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 26,
    fill: "none",
    id: "XMLID_607_",
    r: 2.5,
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 26,
    fill: "none",
    id: "XMLID_608_",
    r: 2.5,
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 26,
    fill: "none",
    id: "XMLID_609_",
    r: 0.5,
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 26,
    fill: "none",
    id: "XMLID_610_",
    r: 0.5,
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "XMLID_611_",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 1.6,
    x2: 1.5,
    y1: 28.5,
    y2: 28.5
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    id: "XMLID_612_",
    points: " 2.5,20.5 1.5,20.5 1.5,22.5 2.5,22.5 ",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 2,
    id: "XMLID_613_",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    width: 2,
    x: 28.5,
    y: 21.5
  }), /*#__PURE__*/React.createElement("path", {
    d: " M4,25.5H2.5c-0.55,0-1-0.45-1-1v-14c0-1.66,1.34-3,3-3h20.72c1.91,0,3.55,1.35,3.92,3.22l1.36,6.78v7c0,0.55-0.45,1-1,1h-3.05",
    fill: "none",
    id: "XMLID_614_",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "XMLID_615_",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 30.5,
    x2: 12.5,
    y1: 30.5,
    y2: 30.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusTransportvehicleSvgrepoCom);
export default __webpack_public_path__ + "static/media/bus-transportvehicle-svgrepo-com.690e4abb9d935629251d775e64d126c1.svg";
export { ForwardRef as ReactComponent };